import type { DocumentUploadSdkConfig } from "@highnoteplatform/types";

import { generateDocumentUploadConfigurationError } from "./errorHandler";

export const verifyDocumentUploadComponentConfig = (
  config: DocumentUploadSdkConfig
): boolean => {
  const {
    clientToken,
    documentUploadSessionId,
    onError,
    documentUploadComponent,
  } = config;

  if (!clientToken || typeof clientToken !== "string" || clientToken === "") {
    onError(generateDocumentUploadConfigurationError("Invalid client token."));
    return false;
  } else if (
    !documentUploadSessionId ||
    typeof documentUploadSessionId !== "string" ||
    documentUploadSessionId === ""
  ) {
    onError(
      generateDocumentUploadConfigurationError("Invalid document session id.")
    );
    return false;
  } else if (
    !documentUploadComponent.selector ||
    documentUploadSessionId === "" ||
    document.querySelector(documentUploadComponent.selector) === null
  ) {
    onError(
      generateDocumentUploadConfigurationError(
        "Invalid document upload component."
      )
    );
    return false;
  } else {
    return true;
  }
};
